import { useEffect, useState } from 'react';

export function useCompact() {
  const [compact, setCompact] = useState(() => matchMedia('(max-width: 860px)').matches);
  useEffect(() => {
    const media = matchMedia('(max-width: 860px)');
    const update = () => setCompact(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return compact;
}
